/* Forme Lab: abas simples com estado na URL (?material=petg, ?uso=...).
   Sem JavaScript, todos os painéis ficam visíveis, um embaixo do outro.
   Marcação: [data-fm-abas data-param="material"] > botões [data-aba="chave"] e painéis [data-painel="chave"].
   Grupos extras sem URL: [data-fm-abas] sem data-param. */
const iniciar = (raiz) => {
  if (raiz.dataset.fmIniciado) return;
  raiz.dataset.fmIniciado = '1';
  const param = raiz.dataset.param;
  const botoes = [...raiz.querySelectorAll('[data-aba]')].filter((b) => b.closest('[data-fm-abas]') === raiz);
  const paineis = [...raiz.querySelectorAll('[data-painel]')].filter((p) => p.closest('[data-fm-abas]') === raiz);
  if (!botoes.length) return;
  const escolher = (chave, gravar) => {
    if (!botoes.some((b) => b.dataset.aba === chave)) chave = botoes[0].dataset.aba;
    botoes.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.aba === chave)));
    paineis.forEach((p) => { p.hidden = p.dataset.painel !== chave; });
    raiz.dispatchEvent(new CustomEvent('fm:aba', { detail: { chave, botao: botoes.find((b) => b.dataset.aba === chave) } }));
    if (gravar && param) {
      try {
        const url = new URL(location.href);
        url.searchParams.set(param, chave);
        history.replaceState(null, '', url);
      } catch (e) {}
    }
  };
  botoes.forEach((b) => b.addEventListener('click', () => escolher(b.dataset.aba, true)));
  let inicial = botoes[0].dataset.aba;
  if (param) {
    const daUrl = new URLSearchParams(location.search).get(param);
    if (daUrl) inicial = daUrl.toLowerCase();
  }
  escolher(inicial, false);
  raiz.classList.add('fm-abas--js');
};
document.querySelectorAll('[data-fm-abas]').forEach(iniciar);
document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-fm-abas]').forEach(iniciar));
